import { render, staticRenderFns } from "./GitDiffFile.vue?vue&type=template&id=fb1e9178&scoped=true"
import script from "./GitDiffFile.vue?vue&type=script&lang=js"
export * from "./GitDiffFile.vue?vue&type=script&lang=js"
import style0 from "./GitDiffFile.vue?vue&type=style&index=0&id=fb1e9178&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb1e9178",
  null
  
)

export default component.exports